// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3wdCj","rootCenter":"LoadMoreObserver_rootCenter__Ta7dI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1qovx"};